import type { AxiosResponse } from 'axios';

import { API } from '@/api';
import { axiosInstance } from '@/utils/fetcher';

import type { CarrierInformationSettings } from '../../types';

export interface GetCarrierInformationSettingsRequestParams {
  carrierKey?: number;
}

export const getCarrierInformationSettingsAPI = (params: GetCarrierInformationSettingsRequestParams) => {
  return axiosInstance.request({
    method: 'get',
    params,
    url: `${API.LOSS_AND_DAMAGE}/GetCarrierClaimsAddress`,
  });
};

export const fetchCarrierInformationSettings = async (
  params: GetCarrierInformationSettingsRequestParams,
): Promise<CarrierInformationSettings> => {
  const response: AxiosResponse<CarrierInformationSettings> = await getCarrierInformationSettingsAPI(params);
  return response.data;
};

export type UpdateCarrierInformationSettingsRequestParams = CarrierInformationSettings;

export const updateCarrierInformationSettingsAPI = (params: UpdateCarrierInformationSettingsRequestParams) => {
  return axiosInstance.request({
    data: { ...params },
    method: 'post',
    url: `${API.LOSS_AND_DAMAGE}/SaveCarrierClaimsAddress`,
  });
};

export const updateCarrierInformationSettings = async (
  params: UpdateCarrierInformationSettingsRequestParams,
): Promise<string> => {
  const response: AxiosResponse<string> = await updateCarrierInformationSettingsAPI(params);
  return response.data;
};
